import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';
import { getToken } from '../../apiCalls/functions/department';

export const commonApiSlice = createApi({
  baseQuery,
  reducerPath: 'commonApiSlice',
  endpoints: (builder) => ({
    getReasons: builder.query({
      query: () => ({
        url: '/data/reasons',
        method: 'GET',
      }),
    }),
    getConfiguration: builder.query({
      query: () => ({
        url: '/data/configuration',
        method: 'GET',
      }),
    }),
    getLanguages: builder.query({
      query: () => ({
        url: '/data/languages',
        method: 'GET',
      })
    }),
    getPendingOrderCRM: builder.query({
      query: () => ({
        url: '/order/pending-order-crm',
        method: 'GET',
      }),
    }),
    getPlanner: builder.query({
      query: () => ({
        url: '/order/planners',
        method: 'POST',
      }),
    }),
    getDownloadCenter: builder.query({
      query: () => ({
        url: '/order/download-centre',
        method: 'GET',
      }),
    }),
    getCounselingAgenda: builder.query({
      query: () => ({
        url: '/data/agenda/MENTORSHIP',
        method: 'GET',
      }),
    }),
    getPopupNotifications: builder.query({
      query: () => ({
        url: '/data/popup/',
        method: 'GET',
      }),
    }),
    getMockTestPaperQuestionAnswer: builder.query({
      query: (data) => ({
        url: '/question/start-quality-test',
        method: 'POST',
        body: data
      }),
    }),
    saveCurrentQuestionAndNext: builder.mutation({
      query: ({ data, paperId }) => ({
        url: '/question/save-test-answer/' + paperId,
        method: 'POST',
        body: data
      }),
    }),
    checkQualityTest: builder.mutation({
      query: ({ data, paperId }) => ({
        url: '/question/check-quality-test/' + paperId,
        method: 'POST',
        body: data
      }),
    }),
    finalSubmitPracticeMcq: builder.mutation({
      query: ({ data, paperId }) => ({
        url: `/question/get-finished-quality-test`,
        method: 'POST',
        body: data
      }),
    }),
    getPracticeMcqAnalytics: builder.query({
      query: ({ subjectId, set }) => ({
        url: '/question/get-finished-quality-test',
        method: 'POST',
        body: { subjectId, set },
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetReasonsQuery,
  useGetConfigurationQuery,
  useGetLanguagesQuery,
  useGetPendingOrderCRMQuery,
  useGetPlannerQuery,
  useGetDownloadCenterQuery,
  useGetCounselingAgendaQuery,
  useGetPopupNotificationsQuery,
  useGetMockTestPaperQuestionAnswerQuery,
  useSaveCurrentQuestionAndNextMutation,
  useFinalSubmitPracticeMcqMutation,
  useCheckQualityTestMutation,
  useGetPracticeMcqAnalyticsQuery,
} = commonApiSlice;
